import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import moment from 'moment';

import { AntaiWarningDto } from 'lib_api/lib/api/gen';

import ErrorMessageCell from 'components/ErrorMessageCell/ErrorMessageCell';
import { TableWithoutSort } from 'components/WrappedComponents';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { useFetchFluxAntai } from 'hooks/antai/useFetchFluxAntai';
import { DATE_FORMAT } from 'utils/formats';

import { useSearchWarningFluxsAntai } from '../utils';

import '../../css/DashboardWarnings.less';

function DashboardWarningsAntai(): React.ReactElement {
  const params = useParams<Record<string, string>>();
  const idFlux = params.id ?? '';

  const navigate = useNavigate();

  const { data: flux } = useFetchFluxAntai(idFlux);

  const { fetchData, pagination, setPagination, filter, setFilter } =
    useSearchWarningFluxsAntai(idFlux);

  function buildDossierLink(data: AntaiWarningDto): React.ReactElement {
    return (
      <Link
        to={`/admin/dossier/${data.dossierId ?? ''}`}
        className={'dossierLink'}
      >
        {data.dossierId}
      </Link>
    );
  }

  function buildColumns(): ColumnProps<AntaiWarningDto>[] {
    return [
      {
        title: 'Id dossier',
        buildCellContent: data => buildDossierLink(data),
      },
      {
        title: 'Id Antai',
        buildCellContent: data => data.antaiId,
      },
      {
        title: 'Date appel',
        buildCellContent: data => moment(data.createdAt).format(DATE_FORMAT),
      },
      {
        title: 'Type de message',
        buildCellContent: data => data.type,
      },
      {
        title: 'Date prochain retry',
        buildCellContent: data =>
          data.nextRetryAt ? moment(data.nextRetryAt).format(DATE_FORMAT) : '-',
      },
      {
        title: 'Nombre de retry',
        buildCellContent: data => data.retriesLeft,
      },
      {
        title: 'Retry locked',
        buildCellContent: data => (data.retryLocked ? 'Oui' : 'Non'),
      },
      {
        title: `Message d'erreur`,
        buildCellContent: data => (
          <ErrorMessageCell
            message={data.message}
            title="Message d'erreur Antai"
          />
        ),
      },
    ];
  }

  const columns: ColumnProps<AntaiWarningDto>[] = React.useMemo(
    () => buildColumns(),
    [],
  );

  return (
    <>
      <div className="dashboardWarningsDossier">
        <div className="headerWarnings">
          <Button
            className="returnButton"
            icon={<ArrowLeftOutlined />}
            onClick={(): void => navigate(-1)}
            type="default"
            shape="round"
            size="middle"
          >
            {'Retour'}
          </Button>
        </div>
        <h1>Antai : Flux de récupération des évènements</h1>
        <h3>
          Détail sur le flux du {moment(flux?.dateDebut).format(DATE_FORMAT)}
        </h3>
        <div className="tableContainer">
          <TableWithoutSort
            columns={columns}
            fetchData={fetchData}
            buildItemKey={(item): string => item.id || ''}
            pageSizeOptions={[10, 20, 50]}
            pagination={pagination}
            setPagination={setPagination}
            filter={filter}
            setFilter={setFilter}
          />
        </div>
      </div>
    </>
  );
}

export default DashboardWarningsAntai;
